import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Profile.module.css';

const AvatarGeneratorModal = ({ 
  isOpen, 
  onClose, 
  prompt, 
  setPrompt, 
  handleGenerateAvatar, 
  isGenerating, 
  tempAvatar, 
  setTempAvatar, 
  handleSaveAvatar, 
  handleDiscardAvatar, 
  avatarHistory,
  handleRemoveAvatar, // Nova prop para remoção
  addNotification // Adicionado para notificações
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose}>X</button>
        <div className={styles.avatarGeneratorContainer}>
          <div className={styles.promptContainer}>
            <input
              type="text"
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              placeholder={t('enterPromptToGenerateAvatar')}
              className="theme-input"
            />
            <button
              onClick={handleGenerateAvatar}
              className={styles['theme-button']}
              disabled={isGenerating}
            >
              {isGenerating ? (
                <div className={styles.ecgAnimation}>
                  <svg viewBox="0 0 100 25" preserveAspectRatio="none">
                    <path
                      id="ecgPath"
                      className={styles.ecgLine}
                      d="M0,20 L10,20 L12,10 L14,30 L16,20 L18,20 L20,20 L22,10 L24,30 L26,20 L28,20 L30,20 L32,10 L34,30 L36,20 L38,20 L40,20 L42,10 L44,30 L46,20 L48,20 L50,20 L52,10 L54,30 L56,20 L58,20 L60,20 L62,10 L64,30 L66,20 L68,20 L70,20 L72,10 L74,30 L76,20 L78,20 L80,20 L82,10 L84,30 L86,20 L88,20 L90,20 L92,10 L94,30 L96,20 L98,20 L100,20"
                    />
                    <path
                      className={styles.ecgTrail}
                      d="M0,20 L10,20 L12,10 L14,30 L16,20 L18,20 L20,20 L22,10 L24,30 L26,20 L28,20 L30,20 L32,10 L34,30 L36,20 L38,20 L40,20 L42,10 L44,30 L46,20 L48,20 L50,20 L52,10 L54,30 L56,20 L58,20 L60,20 L62,10 L64,30 L66,20 L68,20 L70,20 L72,10 L74,30 L76,20 L78,20 L80,20 L82,10 L84,30 L86,20 L88,20 L90,20 L92,10 L94,30 L96,20 L98,20 L100,20"
                    />
                    <circle cx="0" cy="0" r="2" className={styles.ecgDot}>
                      <animateMotion dur="2s" repeatCount="indefinite" rotate="auto">
                        <mpath href="#ecgPath" />
                      </animateMotion>
                    </circle>
                  </svg>
                </div>
              ) : (
                t('generate')
              )}
            </button>
          </div>
          {tempAvatar && (
            <div className={styles.avatarPreviewContainer}>
              <img src={tempAvatar} alt={t('generatedAvatarAlt')} className={styles.avatarPreview} />
              <div className={styles.actionButtons}>
                <button onClick={handleSaveAvatar} className={styles['save-button']}>
                  {t('save')}
                </button>
                <button onClick={handleDiscardAvatar} className={styles['theme-button-discard']}>
                  {t('discard')}
                </button>
              </div>
            </div>
          )}
          <div className={styles.historyContainer}>
            <h3>{t('avatarHistory')}</h3>
            <div className={styles.avatarHistory}>
              {avatarHistory && avatarHistory.length > 0 ? (
                avatarHistory.map((avatar, index) => (
                  <div key={index} className={styles.historyAvatarWrapper}>
                    <img
                      src={avatar}
                      alt={t('historyAvatarAlt', { index: index + 1 })}
                      className={styles.historyAvatar}
                      onClick={() => setTempAvatar(avatar)}
                    />
                    <button
                      className={styles.removeAvatarButton}
                      onClick={() => handleRemoveAvatar(index)}
                    >
                      X
                    </button>
                  </div>
                ))
              ) : (
                <div className={styles.emptyAvatar}>
                  <button
                    className={styles.emptyAvatarButton}
                    onClick={() => addNotification(t('noAvatarSavedYet'), 'info')}
                  >
                    X
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvatarGeneratorModal;
